<template>
  <cms-bulk-action />
</template>

<script>
export default {
  components: {
    CmsBulkAction: () => import('@/components/cms/bulk-action/CmsBulkAction'),
  },
}
</script>